import { ITributoAdicionado, ITributoPossivel, ITributos } from 'interfaces/ITributos';

export function validarTributosExportacaoEConsumo(
  tributosAdicionados: ITributoAdicionado[],
  tributosPossiveis: ITributoPossivel[] | undefined
) {
  if (tributosPossiveis && tributosPossiveis.length) {
    for (const tributo of tributosPossiveis) {
      let tributoPesquisado;
      tributoPesquisado = tributosAdicionados.find((item) => item.nome == tributo.nome);
      if (tributoPesquisado === undefined)
        return `Nas deduções, informe o valor do ${tributo.nome} mesmo que seja zero.`;
    }
  }
  return '';
}

export function validarDeducoes(deducoesAdicionadas: ITributoAdicionado[], deducoesPossiveis: ITributos | undefined) {
  const deducoes = deducoesAdicionadas;
  const deducoesRegularesEEspeciais = [
    ...(deducoesPossiveis?.tributosRegulares ?? []),
    ...(deducoesPossiveis?.tributosEspeciais ?? []),
  ];

  if (deducoesRegularesEEspeciais && deducoesRegularesEEspeciais.length > 0) {
    if (!deducoes || deducoes.length === 0) {
      return 'Por favor, preencha corretamente as deduções.';
    }

    for (const deducao of deducoesRegularesEEspeciais) {
      let deducaoPesquisada;
      deducaoPesquisada = deducoes.find((item) => item.nome === deducao.nome);
      if (deducaoPesquisada === undefined) {
        return `Nas deduções, informe o valor do ${deducao.nome} mesmo que seja zero.`;
      }
    }
  }

  return '';
}
